import React from 'react'
import classNames from 'classnames'

export const DropdownTabItem: React.FunctionComponent<{
  forceHide: boolean
  selected: boolean
  arrowSize: number
  controlColor?: boolean
  children: React.ReactNode
}> = ({
  selected,
  arrowSize,
  children,
  forceHide,
  controlColor,
}) => (
  <div
    style={{
      position: 'relative',
      marginLeft: '10px',
    }}
  >
    {children}
    <svg
      width="30"
      height={arrowSize}
      style={{
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: '50%',
        transform: `translateX(-50%) scaleY(${selected ? 1 : 0})`,
        transformOrigin: 'bottom center',
        opacity: selected ? 1 : 0,
        transition: '300ms',
        transitionDelay: selected || forceHide ? '0ms' : '500ms',
      }}
    >
      <path d={`M 0 ${arrowSize} Z L 15 0 L 30 ${arrowSize} `} className={classNames('downArrow', { controlColor })}/>
    </svg>
  </div>
)